<template>
  <el-dialog
    title="添加字段匹配"
    :visible.sync="dialogVisible"
    width="70%"
    custom-class="edit-module-dialog"
    append-to-body
    destroy-on-close
  >
    <div class="edit-module-container">
      <el-form :inline="true" :rules="rules" :model="form" ref="formRef">
        <div class="field-associated">
          <p class="title">
            <img src="@/assets/field-associated.png" alt="" />
            字段关联
          </p>

          <el-form
            ref="formItemsRef"
            :inline="true"
            v-for="(item, index) in form.items"
            :key="index"
            :model="item"
            :rules="rules"
          >
            <div style="display: flex; justify-content: flex-start">
              <el-form-item prop="formModelKey">
                <el-select
                  placeholder="请选择表单字段"
                  v-model="item.formModelKey"
                  filterable
                  @change="handleFormChange(index, item.formModelKey)"
                >
                  <el-option
                    v-for="item in formOptions"
                    :key="item.model"
                    :label="item.name"
                    :value="item.model"
                    :disabled="item.disabled"
                  />
                </el-select>
              </el-form-item>

              <el-form-item>
                <span>{{ index > 0 ? '由关联模型的' : '关联' }}</span>
              </el-form-item>

              <el-form-item v-if="index === 0">
                <el-cascader
                  v-model="form.warehouseModel"
                  placeholder="请选择数据模型"
                  :show-all-levels="false"
                  :options="modelOptions"
                  :props="modelProps"
                  filterable
                  @change="handleTableNameChange"
                />
              </el-form-item>

              <el-form-item v-if="index === 0">
                <span>的</span>
              </el-form-item>

              <el-form-item prop="warehouseModelKey">
                <el-select
                  placeholder="请选择模型字段"
                  v-model="item.warehouseModelKey"
                  filterable
                  @change="handleModelChange(index, item.warehouseModelKey)"
                >
                  <el-option
                    v-for="item in fieldOptions"
                    :key="item.columnName"
                    :label="item.comment"
                    :value="item.columnName"
                  />
                </el-select>
                <span v-if="index > 0"> 自动填充 </span>
              </el-form-item>

              <el-form-item v-if="index > 0">
                <p class="icons">
                  <img src="@/assets/add.png" @click="handleAdd" />
                  <img src="@/assets/delete.png" @click="handleDelete(index)" />
                </p>
              </el-form-item>
            </div>

            <el-checkbox
              v-if="index === 0"
              :disabled="autoFillingDisabled"
              v-model="autoFilling"
              >同时根据关联的模型自动填充其它字段</el-checkbox
            >
          </el-form>
        </div>

        <div class="data-associated">
          <p class="title">
            <img src="@/assets/data-associated.png" alt="" />
            数据关联
          </p>

          <el-form-item prop="warehouseModel">
            <el-cascader
              disabled
              v-model="form.warehouseModel"
              placeholder="请选择数据模型"
              :show-all-levels="false"
              :options="modelOptions"
              :props="modelProps"
              filterable
            />
          </el-form-item>

          <el-form-item>
            <span>的</span>
          </el-form-item>

          <el-form-item prop="matchItem">
            <el-select
              placeholder="请选择模型中的字段"
              v-model="form.matchItem"
              @change="handleMatchItemChange"
            >
              <el-option
                v-for="item in matchRelationOptions"
                :key="item.columnName"
                :label="item.columnDesc"
                :value="item.columnName"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <span>匹配</span>
          </el-form-item>

          <el-form-item prop="matchSelector">
            <el-select
              placeholder="请选择用户相关信息"
              v-model="form.matchSelector"
              @change="handleMatchSelectorChange"
            >
              <el-option
                v-for="item in matchRelationOptions"
                :key="item.userRelation"
                :label="item.userRelationText"
                :value="item.userRelation"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button plain @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getWarehouseDomainGroupModelMenu,
  getWarehouseDomainGetComponent,
  getMatchRelation,
} from '@/api/index'
export default {
  props: {
    currentParams: Object,
    visible: Boolean,
    list: Array,
    sonPages: Object,
    modelJson: Array,
  },
  data() {
    return {
      modelOptions: [],
      modelProps: {
        label: 'name',
        value: 'id',
        emitPath: false,
      },
      formOptions: [],
      fieldOptions: [],
      form: {
        warehouseModel: '',
        warehouseModelLabel: '',
        matchItem: '',
        matchItemLabel: '',
        matchSelector: '',
        matchSelectorLabel: '',
        matchTableName: '',
        items: [
          {
            tableName: '',
            formModelKey: '',
            formModelLabel: '',
            warehouseModelKey: '',
            warehouseModelLabel: '',
            subModelName: '',
          },
        ],
      },
      rules: {
        formModelKey: [
          { required: true, message: '请选择表单字段', trigger: 'change' },
        ],
        warehouseModelKey: [
          { required: true, message: '请选择模型字段', trigger: 'change' },
        ],
        matchItem: [
          { required: true, message: '请选择模型中的字段', trigger: 'change' },
        ],
        tableName: [
          { required: true, message: '请选择模型中的字段', trigger: 'change' },
        ],
        matchSelector: [
          { required: true, message: '请选择用户相关信息', trigger: 'change' },
        ],
      },
      matchRelationOptions: [],
      autoFilling: false, // 是否开启自动填充
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    autoFillingDisabled() {
      return (
        this.form.warehouseModel === '' ||
        this.form?.items[0]?.formModelKey === ''
      )
    },
  },

  watch: {
    dialogVisible(value) {
      if (value) {
        // 获取模型列表
        this.handleGetModelList()
        // 获取表单字段
        this.handleGetFormOptions(this.list)

        if (this.currentParams) {
          // 编辑4
          this.form = {
            ...this.currentParams,
          }

          if (this.form.items && this.form.items.length > 1) {
            this.autoFilling = true
          }

          this.handleTableNameChange(this.form.warehouseModel, 'init')
        } else {
          // 新增
          this.handleReset()
        }

        this.$nextTick(() => {
          this.$refs.formRef.clearValidate()
          this.$refs.formItemsRef.forEach(item => {
            item.clearValidate()
          })

          // 已经绑定过的字段 无法重复选择
          let existsData = []
          this.modelJson.map(modelItem => {
            existsData = existsData.concat(modelItem.items)
          })

          existsData.map(existItem => {
            const index = this.formOptions.findIndex(
              item => item.model === existItem.formModelKey
            )
            if (index > -1) {
              this.formOptions[index] = {
                ...this.formOptions[index],
                disabled: true,
              }
            }
          })
        })
      } else {
        this.formOptions = []
        this.modelOptions = []
        this.fieldOptions = []
      }
    },
    autoFilling(value) {
      this.handleCheckedChange(value)
    },
  },
  methods: {
    // 清空重置
    handleReset() {
      this.form = {
        warehouseModel: '',
        warehouseModelLabel: '',
        matchItem: '',
        matchItemLabel: '',
        matchSelector: '',
        matchSelectorLabel: '',
        matchTableName: '',
        items: [
          {
            tableName: '',
            formModelKey: '',
            formModelLabel: '',
            warehouseModelKey: '',
            warehouseModelLabel: '',
            subModelName: '',
          },
        ],
      }
      this.autoFilling = false
    },

    // 添加
    handleAdd() {
      this.form.items.push({
        tableName: '',
        formModelKey: '',
        formModelLabel: '',
        warehouseModelKey: '',
        warehouseModelLabel: '',
        subModelName: '',
      })
    },
    // 删除
    handleDelete(index) {
      this.form.items.splice(index, 1)
    },
    // 是否自动填充其他字段
    handleCheckedChange(value) {
      if (value) {
        this.formOptions.map(formItem => {
          this.fieldOptions.map(fieldItem => {
            if (
              (formItem.model === fieldItem.columnName ||
                formItem.name === fieldItem.comment) &&
              this.form.items[0].formModelKey !== formItem.model
            ) {
              if (!formItem.disabled) {
                const fieldIndex = this.fieldOptions.findIndex(
                  item => item.columnName === fieldItem.columnName
                )

                this.form.items.push({
                  tableName: this.fieldOptions[fieldIndex].tableName,
                  formModelKey: formItem.model,
                  formModelLabel: formItem.name,
                  warehouseModelKey: fieldItem.columnName,
                  warehouseModelLabel: fieldItem.comment,
                  subModelName: formItem.parentModel
                    ? formItem.parentModel
                    : '',
                })
              }
            }
          })
        })
      } else {
        this.form.items.splice(1, this.form.items.length - 1)
      }
    },

    // 数据模型切换
    handleTableNameChange(modelId, type) {
      this.form.warehouseModel = modelId
      if (type !== 'init') {
        if (modelId) {
          this.form.matchItem = ''
          this.form.matchSelector = ''

          this.modelOptions.map(item => {
            item.children.map(child => {
              child.children.map(childItem => {
                if (childItem.id === modelId) {
                  this.form.warehouseModelLabel = childItem.name
                }
              })
            })
          })
          this.form.items.map(item => {
            item.warehouseModelKey = ''
            item.warehouseModelLabel = ''
          })
          this.autoFilling = false
        }
      }

      this.handleGetMatchRelation()
      this.handleGetComponent()
    },

    // 表单字段切换
    handleFormChange(itemIndex, value) {
      const index = this.formOptions.findIndex(item => item.model === value)
      this.form.items[itemIndex].formModelLabel = this.formOptions[index].name
      this.form.items[itemIndex].subModelName = this.formOptions[index]
        .parentModel
        ? this.formOptions[index].parentModel
        : ''

      if (itemIndex === 0) {
        if (this.autoFilling) {
          if (this.form.items && this.form.items.length > 1) {
            this.form.items.splice(1, this.form.items.length - 1)
            this.handleCheckedChange(this.autoFilling)
          }
        }
      }
    },

    // 模型字段切换
    handleModelChange(itemIndex, value) {
      const index = this.fieldOptions.findIndex(
        item => item.columnName === value
      )
      this.form.items[itemIndex].warehouseModelLabel =
        this.fieldOptions[index].comment

      this.form.items[itemIndex].tableName = this.fieldOptions[index].tableName
    },

    // 切换
    handleMatchItemChange(value) {
      if (value) {
        const index = this.matchRelationOptions.findIndex(
          item => item.columnName === value
        )
        this.form.matchItemLabel = this.matchRelationOptions[index].columnDesc
        this.form.matchSelector = this.matchRelationOptions[index].userRelation
        this.form.matchSelectorLabel =
          this.matchRelationOptions[index].userRelationText
        this.form.matchTableName = this.matchRelationOptions[index].tableName
      }
    },

    handleMatchSelectorChange(value) {
      if (value) {
        const index = this.matchRelationOptions.findIndex(
          item => item.userRelation === value
        )

        this.form.matchSelectorLabel =
          this.matchRelationOptions[index].userRelationText
        this.form.matchItem = this.matchRelationOptions[index].columnName
        this.form.matchItemLabel = this.matchRelationOptions[index].columnDesc
        this.form.matchTableName = this.matchRelationOptions[index].tableName
      }
    },

    // 获取数据模型数据
    async handleGetModelList() {
      try {
        const res = await getWarehouseDomainGroupModelMenu()
        this.modelOptions = res.data || []
        this.modelOptions.map(item => {
          item.disabled = !(item.children && item.children.length > 0)
          item.children.map(child => {
            child.disabled = !(child.children && child.children.length > 0)
            child.children.map(childs => {
              childs.disabled = !childs.available
            })
          })
        })
      } catch (error) {
        console.log('error', error)
      } finally {
        //
      }
    },

    // 根据模型id获取模型下的字段
    async handleGetComponent() {
      this.fieldOptions = []
      try {
        const modelId = this.form.warehouseModel
        const res = await getWarehouseDomainGetComponent(modelId)
        if (res.data) {
          const { mainTable = [], subTable = [] } = res.data
          for (let key in mainTable) {
            mainTable[key].forEach((item, index) => {
              this.fieldOptions.push({
                ...mainTable[key][index],
                tableName: key,
              })
            })
          }

          subTable.map(subItem => {
            subItem.columns.filter(item => {
              item.tableName = subItem.tableName
              this.fieldOptions.push({
                ...item,
              })
            })
          })
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        //
      }
    },

    // 数据仓库用户数据匹配列表查询
    async handleGetMatchRelation() {
      if (!this.form.warehouseModel) return
      try {
        const params = {
          modelId: this.form.warehouseModel,
        }
        const res = await getMatchRelation(params)
        if (res.flag) {
          const arrData = [
            {
              label: '部门id',
              value: 'ORGANIZATION_ID',
            },
            {
              label: '部门名称',
              value: 'ORGANIZATION_NAME',
            },
            {
              label: '部门code',
              value: 'ORGANIZATION_CODE',
            },
            {
              label: '学工号',
              value: 'ACCOUNT_NAME',
            },
            {
              label: '姓名',
              value: 'USER_NAME',
            },
            {
              label: '账户id',
              value: 'ACCOUNT_ID',
            },
          ]
          const data = res?.data || []
          this.matchRelationOptions = data.filter(item => item.userRelation)

          // this.matchRelationOptions = res?.data || []
          this.matchRelationOptions.map(item => {
            arrData.map(dataItem => {
              if (item.userRelation === dataItem.value) {
                item.userRelationText = dataItem.label
              }
            })
          })
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        //
      }
    },

    // 获取表单字段
    handleGetFormOptions(data, parentModel = '') {
      const list = data

      for (var i = 0, l = list.length; i < l; i++) {
        //遍历出子表单
        if (list[i]['type'] === 'sonform') {
          //子表单主项
          // this.formOptions.push({
          //   name: list[i]['name'],
          //   model: list[i]['model'],
          // })
          //子表单子项
          this.getSonFormData(list[i]['list'], list[i]['model'])
        } else if (list[i]['type'] === 'grid') {
          //遍历出栅格
          this.getGridFormCom(list[i]['columns'], this.formOptions)
        } else if (list[i]['type'] === 'page') {
          this.getSonPageCom(
            list[i]['options']['selectPage'],
            this.sonPages,
            this.formOptions
          )
        } else if (list[i]['type'] === 'divider') {
          var xuxian1 = list[i]['options']['defaultValue']
          xuxian1 = xuxian1.replace(/<[^>]+>/g, '')
          if (xuxian1.length > 10) {
            xuxian1 = xuxian1.slice(0, 10) + '...'
          }
          this.formOptions.push({
            name: xuxian1,
            model: list[i]['model'],
          })
        } else if (list[i]['type'] === 'comment') {
          this.formOptions.push({
            name: list[i]['name'],
            model: list[i]['model'],
          })

          this.getCommentCom(list[i]['list'], this.formOptions)
        } else if (list[i]['type'] === 'report') {
          this.getReportData(list[i].rows)
        } else {
          this.formOptions.push({
            name: list[i]['name'],
            model: list[i]['model'],
            parentModel: parentModel ? parentModel : '',
          })
        }
      }
    },

    getSonFormData(list) {
      for (var j = 0; j < list.length; j++) {
        if (list[j]['type'] === 'divider') {
          var xuxian3 = list[j]['options']['defaultValue']
          xuxian3 = xuxian3.replace(/<[^>]+>/g, '')
          // if (xuxian3.length > 10) {
          //   xuxian3 = xuxian1.slice(0, 10) + '...'
          // }
          this.formOptions.push({
            name: xuxian3,
            model: list[j]['model'],
          })
        } else {
          this.formOptions.push({
            name: list[j]['name'],
            model: list[j]['model'],
          })
        }
      }
    },

    getReportData(rows) {
      rows.forEach(row => {
        row.columns.forEach(column => {
          column.list.forEach(listItem => {
            if (listItem.type === 'grid') {
              this.getGridFormCom(listItem['columns'], this.formOptions)
            } else if (listItem.type === 'comment') {
              this.getCommentCom(listItem['list'], this.formOptions)
            } else if (listItem.type === 'sonform') {
              //
            } else {
              if (listItem.model) {
                this.formOptions.push({
                  name: listItem.name,
                  model: listItem.model,
                })
              }
            }
          })
        })
      })
    },

    getCommentCom(data, form) {
      for (var j = 0; j < data.length; j++) {
        //不支持评阅里面嵌套子表单 这里注释掉代码
        if (data[j]['type'] === 'sonform') {
          //
        } else if (data[j]['type'] === 'page') {
          // $scope.getSonPageCom(aqw[j]["options"]["selectPage"],sonPages);
        } else if (data[j]['type'] === 'grid') {
          this.getCommentGridFormCom(data[j]['columns'], form)
        } else if (data[j]['type'] === 'divider') {
          var xuxian = data[j]['options']['defaultValue']
          xuxian = xuxian.replace(/<[^>]+>/g, '')

          this.formOptions.push({
            name: xuxian,
            model: data[j]['model'],
          })
        } else {
          this.formOptions.push({
            name: data[j]['name'],
            model: data[j]['model'],
          })
        }
      }
    },

    getSonPageCom(key, sonPages, form) {
      var aqw = sonPages[key]['list']
      for (var j = 0; j < aqw.length; j++) {
        if (aqw[j]['type'] === 'sonform') {
          //子表单主项
          this.formOptions.push({
            name: aqw[j]['name'],
            model: aqw[j]['model'],
          })
          //子表单子项
          for (var m = 0; m < aqw[j]['list'].length; m++) {
            if (aqw[j]['list'][m]['type'] === 'divider') {
              var xuxian3 = aqw[j]['list'][m]['options']['defaultValue']
              xuxian3 = xuxian3.replace(/<[^>]+>/g, '')
              // if (xuxian3.length > 10) {
              //   xuxian3 = xuxian1.slice(0, 10) + '...'
              // }
              this.formOptions.push({
                name: xuxian3,
                model: aqw[j]['list'][m]['model'],
              })
            } else {
              this.formOptions.push({
                name: aqw[j]['list'][m]['name'],
                model: aqw[j]['list'][m]['model'],
              })
            }
          }
        } else if (aqw[j]['type'] === 'page') {
          this.getSonPageCom(aqw[j]['options']['selectPage'], sonPages, form)
        } else if (aqw[j]['type'] === 'grid') {
          this.getGridFormCom(aqw[j]['columns'], form)
        } else if (aqw[j]['type'] === 'divider') {
          var xuxian = aqw[j]['options']['defaultValue']
          xuxian = xuxian.replace(/<[^>]+>/g, '')
          this.formOptions.push({
            name: xuxian,
            model: aqw[j]['model'],
          })
        } else {
          this.formOptions.push({
            name: aqw[j]['name'],
            model: aqw[j]['model'],
          })
        }
      }
    },

    getGridFormCom(data, form) {
      for (var j = 0; j < data.length; j++) {
        for (var k = 0; k < data[j]['list'].length; k++) {
          if (data[j]['list'][k]['name'] != '') {
            if (data[j]['list'][k]['type'] === 'grid') {
              //栅格里面还有栅格  递归遍历
              this.getGridFormCom(data[j]['list'][k]['columns'], form)
            } else if (data[j]['list'][k]['type'] === 'divider') {
              var xuxian2 = data[j]['list'][k]['options']['defaultValue']
              xuxian2 = xuxian2.replace(/<[^>]+>/g, '')
              // if (xuxian2.length > 10) {
              //   xuxian2 = xuxian2.slice(0, 10) + '...'
              // }
              this.formOptions.push({
                name: xuxian2,
                model: data[j]['list'][k]['model'],
              })
            } else {
              this.formOptions.push({
                name: data[j]['list'][k]['name'],
                model: data[j]['list'][k]['model'],
              })
            }
          }
        }
      }
    },

    getCommentGridFormCom(data, form) {
      for (var j = 0; j < data.length; j++) {
        for (var k = 0; k < data[j]['list'].length; k++) {
          if (data[j]['list'][k]['name'] != '') {
            if (data[j]['list'][k]['type'] === 'grid') {
              //栅格里面还有栅格  递归遍历
              this.getCommentGridFormCom(data[j]['list'][k]['columns'], form)
            } else if (data[j]['list'][k]['type'] === 'divider') {
              var xuxian2 = data[j]['list'][k]['options']['defaultValue']
              xuxian2 = xuxian2.replace(/<[^>]+>/g, '')
              // if (xuxian2.length > 10) {
              //   xuxian2 = xuxian2.slice(0, 10) + '...'
              // }
              this.formOptions.push({
                name: xuxian2,
                model: data[j]['list'][k]['model'],
              })
            } else {
              this.formOptions.push({
                name: data[j]['list'][k]['name'],
                model: data[j]['list'][k]['model'],
              })
            }
          }
        }
      }
    },

    // 取消
    handleClose() {
      this.dialogVisible = false
    },

    // 确定
    handleSubmit() {
      let that = this
      Promise.all(
        this.$refs.formItemsRef.map(formItem => formItem.validate())
      ).then(valid => {
        if (valid.every(vItem => vItem)) {
          that.$refs.formRef.validate(validRes => {
            if (validRes) {
              console.log(that.form, 'that.form')
              that.$emit('success', that.form)
              that.dialogVisible = false
            }
          })
        } else {
          console.log('error!')
          return false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.edit-module-dialog) {
  p {
    margin: 0;
    padding: 0;
  }
  .el-dialog__header {
    padding: 10px 20px;
    background: #f8fafc;
    .el-dialog__title {
      font-size: 16px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: '';
        position: absolute;
        top: 3px;
        left: 0;
        width: 4px;
        height: 16px;
        background: #205cff;
        border-radius: 1px;
      }
    }

    .el-dialog__headerbtn {
      top: 13px;
    }
  }

  .el-dialog__body {
    font-size: 12px;
    // min-height: calc(80vh - 100px);
    // overflow: auto;
    padding: 25px;

    .edit-module-container {
      .field-associated,
      .data-associated {
        .title {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-bottom: 15px;
          img {
            display: block;
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }

        .el-form {
          .el-form-item {
            margin-bottom: 14px;
            .icons {
              display: flex;
              align-items: center;
              img {
                cursor: pointer;
                width: 24px;
                height: 24px;
                margin-top: 5px;
                &:first-child {
                  margin-right: 8px;
                }
              }
            }
          }

          .el-checkbox {
            margin-bottom: 14px;
          }
        }
      }

      .data-associated {
        margin-top: 12px;
      }
    }
  }

  .el-dialog__footer {
    border-top: 1px solid #ecf0f6;
    padding: 15px 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
